export default {
  os_in_review: "審核中",
  os_loan_approved: "貸款已通過",
  os_loans_have_been_closed: "貸款已關閉",
  os_loan_refused: "貸款已拒絕",
  os_in_the_lending: "放款中",
  os_overdue: "已逾期",
  os_for_reimbursement: "待還款",
  os_the_loan_has_been_cleared: "貸款已結清",
 
  os_the_loan_reject: "貸款拒絕",
  os_the_loan_cancel: "貸款取消",
  os_the_loan_fail: "放款失敗",
  os_the_loan_settle: "貸款結清",
  os_the_loan_overdue: "貸款逾期",
  os_the_loan_timeout_refuse: "逾時拒絕",
  os_the_loan_return: "退回",
  os_the_loan_withdraw: "待領取",
}


/**
 * 審核中 Đang xem xét
 * 貸款已通過 khoản vay đã thông qua
 * 貸款已關閉 khoản vay đã đóng
 * 貸款已拒絕 khoản vay bị từ chối
 * 放款中 đã giải ngân
 * 已逾期 quá hạn
 * 待還款 sắp hoàn trả
 * 貸款已結清 khoản vay đã được giải quyết
 */